import * as React from "react"
import { graphql } from 'gatsby';
import NotFound from 'pages/404';
import useLiveData from 'hooks/useLiveData';
import Service from "components/Service/Service";

const DepartmentGet = props => {
	const { edges } = props.data.allDepartment;
	const nodes = edges.map(({node}) => node);
	const {statusText: providerStatusText, status: providerStatus, response: providerResponse, visibilityChange} = useLiveData({
		type: 'Department',
		apiParams: {
			approved: true,
			deleted: false,
			archived: false,
			inListing: true,
			uri: props.location.pathname,
			_join: true,
		},
		staticData: props.data,
	});
	let service = nodes[0];
	if (((providerResponse && providerResponse.data.length > 0) || !!service !== false) && providerStatusText === 'LOADED') {
		service = providerResponse.data[0];
	}
	if (providerResponse && visibilityChange)service = providerResponse.data[0];
	if (!!service === false && providerStatus >= 2)return <NotFound/>; // We only go to a service not found after the API loads or has an error and there's no service found.
	// if (props.providerStatus < 2){// This prevents any flash of content until the API is loaded -- but if the API takes a while to respond the effect would be the service loads slower. You could also use state to reveal content with a transition
	// 	return null;
	// }
	return (
		<div className={`loadWrap ${providerStatus >= 2 ? 'loaded' : ''}`}>
			{ providerStatus >= 2 && <Service service={service} /> }
		</div>
	)
}

export default DepartmentGet;

export { Head } from 'components/Head';

export const query = graphql`
	query ($uri: String) {
	  allDepartment(
		filter: {uri: {eq: $uri}, approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}, inListing: {eq: true}}
	  ) {
		edges {
		  node {
			id
			name
		    description
			headerImage
			image
			icon
			heroTitle
			heroText
			services
		    uri
			Post {
				object {
					id
					uri
					title
					intro
					photo
				}
			}
			CaseStudy {
			    object {
					id
					title
					headerImage
					uri
				}
			}
		  }
		}
	  }
	}
`